/**
 * applyMixins — merge per-domain API class prototypes onto AdminAPIClient
 * (CUR-547 split). Standard TypeScript mixin helper: copies every prototype
 * method (skipping constructors) from each domain class onto the derived
 * class, so the flat `apiClient.method()` surface survives the file split
 * with zero call-site churn.
 *
 * Pair every applyMixins() call with a `export interface AdminAPIClient
 * extends …` declaration so the type system sees the merged surface.
 */

type Constructor = new (...args: any[]) => object;

export function applyMixins(derivedCtor: Constructor, constructors: Constructor[]): void {
  constructors.forEach((baseCtor) => {
    Object.getOwnPropertyNames(baseCtor.prototype).forEach((name) => {
      if (name === 'constructor') return;
      const descriptor = Object.getOwnPropertyDescriptor(baseCtor.prototype, name);
      if (descriptor) {
        Object.defineProperty(derivedCtor.prototype, name, descriptor);
      }
    });
  });
}
